import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { Container, Row, Col, Card, CardBody, CardText, CardHeader } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import Table from "./Table";
import { FiltersCard } from "components/Common/FiltersCard";
import axios from "axios";
import { API_URL, sitename } from "constants/constants";
import { showErrorMessages } from "helpers/helpers";
import { showMessage } from "../../../components/Common/Toaster";
import TableLoader from "../../../components/Common/TableLoader";
import moment from "moment";

const BookABetTickets = props => {
  const [item, setItem] = useState("All");
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [liveData, setLive] = useState("prematch");
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [loadingMessage, setLoadingMessage] = useState("1");
  const [filtersData, setFiltersData] = useState({
    item: "",
    fromDate: "",
    toDate: "",
  });
  const [data, setData] = useState([]);
  const [modelData, setModalData] = useState([]);
  const [totalTickets, setTotalTickets] = useState(0);
  const [totalStakes, setTotalStakes] = useState(0);
  const [payout, setPayout] = useState(0);
  const [GGR, setGGR] = useState(0);

  const options = [
    { label: "Lost", value: "Lost" },
    { label: "Won", value: "Won" },
    { label: "All", value: "All" },
    { label: "Pending", value: "Pending" },
    { label: "Void", value: "Void" },
  ];

  useEffect(() => {
    call();
  }, [fromDate, toDate, item, liveData]);

  const call = () => {
    setLoadingMessage("1");
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/book-a-bet-tickets?to=${toDate}&from=${fromDate}&type=${item}&match_type=${liveData}`,
    })
      .then(response => {
        const responseData = response?.data?.data || [];
        setData(responseData);
        setLoadingMessage("0");
  
        // Calculate the total tickets, total stakes, payout, and GGR
        const totalTicketsCount = responseData.length;
        const totalStakesValue = responseData.reduce((sum, ticket) => sum + parseFloat(ticket.stake_after_tax), 0);
        const totalPayoutValue = responseData
          .filter(ticket => ticket.status === 1)
          .reduce((sum, ticket) => sum + parseFloat(ticket.to_win || 0), 0);
        const totalGGRValue = totalStakesValue - totalPayoutValue;
  
        setTotalTickets(totalTicketsCount);
        setTotalStakes(totalStakesValue);
        setPayout(totalPayoutValue);
        setGGR(totalGGRValue);
      })
      .catch(error => {
        console.error("Error fetching book-a-bet tickets data:", error);
        setLoadingMessage("0");
      });
  }; 
  

  const callById = id => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/book-a-bet-tickets?id=${id}&match_type=${liveData}`,
    })
      .then(response => {
        setModalData(response?.data?.data[0]);
      })
      .catch(error => {
        console.error("Error fetching book-a-bet ticket by ID:", error);
      })
  };

  const cancelTicketCall = id => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/cancel-tickets/${id}`,
    })
      .then(response => {
        showMessage("success", response.data.message);
        call();
      })
      .catch(error => {
        showErrorMessages(error);
      });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Book-A-Bet Tickets" />
        </Container>
        <Row>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total Tickets</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{totalTickets.toLocaleString()}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total Stakes</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalStakes.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Payout</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {payout.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
  <Card>
    <CardHeader className="bg-transparent border-bottom text-uppercase">GGR</CardHeader>
    <CardBody>
      <blockquote className="card-blockquote mb-0">
        <CardText className="font-size-16" style={{ color: GGR < 0 ? "red" : "green" }}>
          {GGR.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </CardText>
      </blockquote>
    </CardBody>
  </Card>
</Col>

        </Row>
        <FiltersCard
          item={item}
          setItem={setItem}
          options={options}
          fromDate={fromDate}
          toDate={toDate}
          setToDate={setToDate}
          setFromDate={setFromDate}
          showToDate={true}
          setFiltersData={setFiltersData}
          call={() => {
            call();
          }}
          hideShowType={false}
        />
        <Table
          data={data}
          modelData={modelData}
          liveData={liveData}
          setLive={setLive}
          callById={id => {
            callById(id);
          }}
          call={() => {
            call();
          }}
          cancelTicketCall={id => {
            cancelTicketCall(id);
          }}
          loadingMessage={loadingMessage}
          setLoadingMessage={setLoadingMessage}
        />
      </div>
    </React.Fragment>
  );
};

export default withRouter(BookABetTickets);
